/**
 * @module jsonCopy
 * @since 2.0.0
 */

/**
 * Creates a deep copy using JSON functionalities. Very performant, yet not a comprehensive copyier.
 * @param   {*} data The value to copy.
 * @returns {*}
 */
export function jsonCopy(data) {
    try {
        return JSON.parse(JSON.stringify(data));
    } catch (error) {
        throw new SyntaxError(`Data was expected to be valid for JSON. Got error: ${error}`);
    }
}
